import { useControllableState } from '@/hook';

import VBaseCheckboxRadioContext from './context';
import type { VBaseCheckboxRadioContextValue } from './type';

const VBaseCheckboxRadioContextProvider = ({
  children,
  checked,
  onCheckedChange,
  id,
  defaultChecked,
  ...rest
}: React.PropsWithChildren<VBaseCheckboxRadioContextValue>) => {
  const [_checked, _onCheckedChange] = useControllableState({
    prop: checked,
    defaultProp: defaultChecked ?? false,
    onChange: onCheckedChange,
  });

  const handleCheckedChange = (checked: boolean | 'indeterminate') => {
    if (rest.disabled) return;
    _onCheckedChange?.(checked as boolean | 'indeterminate');
  };

  return (
    <VBaseCheckboxRadioContext.Provider
      value={{
        id,
        checked: _checked,
        onCheckedChange: handleCheckedChange,
        ...rest,
      }}
    >
      {children}
    </VBaseCheckboxRadioContext.Provider>
  );
};
export default VBaseCheckboxRadioContextProvider;
